import { Fragment, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useFnol } from '../../context';
import fnolServices from '../../services/fnolServices';

import {
  ItemContainer,
  PrimaryButton,
  SecondaryButton,
} from '../../components';

import { STEP_CONTACT_INFORMATION, STEP_FNOL_RECIEVED } from '../../CONSTANTS';

import { formatDateTime } from '../../utils';
import ButtonWrapper from '../../components/ButtonWrapper';

const SendFNOLView = () => {
  const {
    customerInformation,
    fnolTemplate,
    incidentDay,
    selectedFnolTemplate,
    setStep,
  } = useFnol();

  const { t } = useTranslation();

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  const handleSubmitFnolClick = async () => {
    await fnolServices.complete(
      fnolTemplate.fnolKey,
      customerInformation.email,
      customerInformation.telephone
    );

    setStep(STEP_FNOL_RECIEVED);
  };
  const handleGoBackClick = () => setStep(STEP_CONTACT_INFORMATION);

  const getFormattedAnswer = (answer) => {
    switch (answer.tag) {
      case 'Double':
      case 'Int':
        return answer.contents.toLocaleString('sv-SE');
      case 'Time':
        return formatDateTime(answer.contents);
      case 'YesNo':
        return answer.contents === 'Yes' ? t('yes') : t('no');
      default:
        return answer.contents;
    }
  };

  return (
    <>
      <H3>{t('sendFnol.header')}</H3>
      <p>{t('sendFnol.text')}</p>

      {(fnolTemplate.insuredObject.tag === 'Address' ||
        fnolTemplate.insuredObject.tag === 'Product') && (
        <ItemContainer>
          <label>
            {selectedFnolTemplate.category.insuranceHolderQuery.contents}
          </label>
          {customerInformation.insuranceHolder}
        </ItemContainer>
      )}
      <ItemContainer>
        <label>
          {selectedFnolTemplate.category.insuredObjectQuery.contents}
        </label>
        {customerInformation.insuredObject}
      </ItemContainer>
      <H4>{t('selectFnolCategory.header')}</H4>
      <ItemContainer>
        <label>{t('sendFnol.templateLabel')}</label>
        {fnolTemplate.reportName}
      </ItemContainer>
      <ItemContainer>
        <label>{selectedFnolTemplate.category.incidentDayQuery}</label>
        {t('intlDateTime', { date: new Date(incidentDay) })}
      </ItemContainer>
      <H4>{t('questions.header')}</H4>
      {fnolTemplate.questions.length > 0 &&
        fnolTemplate.questions.map((question) => (
          <Fragment
            key={
              question.contents.tag === 'AnsweredNode'
                ? question.contents.answeredQuestion.key
                : question.contents.question.key
            }
          >
            <ItemContainer>
              <label>
                {question.contents.tag === 'AnsweredNode'
                  ? question.contents.answeredQuestion.question
                  : question.contents.question.question}
              </label>
              {question.contents.tag === 'AnsweredNode'
                ? getFormattedAnswer(question.contents.answeredQuestion.answer)
                : t('sendFnol.notAnswered')}
            </ItemContainer>
            {question.contents.tag === 'AnsweredNode' &&
              question.contents.listOfQuestionTreeOut &&
              question.contents.listOfQuestionTreeOut.length > 0 &&
              question.contents.listOfQuestionTreeOut.map((tree) => (
                <ItemContainer
                  key={
                    tree.tag === 'AnsweredNode'
                      ? tree.answeredQuestion.key
                      : tree.question.key
                  }
                >
                  <label>
                    {tree.tag === 'AnsweredNode'
                      ? tree.answeredQuestion.question
                      : tree.question.question}
                  </label>
                  {tree.tag === 'AnsweredNode'
                    ? getFormattedAnswer(tree.answeredQuestion.answer)
                    : t('sendFnol.notAnswered')}
                </ItemContainer>
              ))}
          </Fragment>
        ))}
      <H4>{t('contactInformation.header')}</H4>
      <ItemContainer>
        <label>{t('contactInformation.telephone.label')}</label>
        {customerInformation.telephone}
      </ItemContainer>
      <ItemContainer>
        <label>{t('contactInformation.email.label')}</label>
        {customerInformation.email}
      </ItemContainer>
      <ItemContainer>
        <label>{t('sendFnol.attachments')}</label>
        {fnolTemplate.attachments.length > 0 ? (
          <Attachments>
            {fnolTemplate.attachments.map((attachment) => (
              <li>{attachment.filename}</li>
            ))}
          </Attachments>
        ) : (
          <span>{t('sendFnol.noAttachments')}</span>
        )}
      </ItemContainer>
      <ButtonWrapper>
        <SecondaryButton onClick={handleGoBackClick}>
          {t('buttons.back')}
        </SecondaryButton>
        <PrimaryButton onClick={handleSubmitFnolClick}>
          {t('buttons.send')}
        </PrimaryButton>
      </ButtonWrapper>
    </>
  );
};

export default SendFNOLView;

const Attachments = styled.ul`
  list-style: none;
  padding: 0;
`;

const H3 = styled.h3`
  font-family: ${(props) => props.theme.h3.fontFamily};
  color: ${(props) => props.theme.h3.fontColor};
  font-weight: ${(props) => props.theme.h3.fontWeight};
  font-size: ${(props) => props.theme.h3.fontSize};
`;

const H4 = styled.h4`
  font-family: ${(props) => props.theme.h4.fontFamily};
  color: ${(props) => props.theme.h4.fontColor};
  font-weight: ${(props) => props.theme.h4.fontWeight};
  font-size: ${(props) => props.theme.h4.fontSize};
`;
